import { FC } from "react";

export const ArrowRightIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      width="21"
      height="14"
      viewBox="0 0 21 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className || ""}`}
    >
      <path
        d="M13.5 14L12.075 12.6L16.675 8H0.5V6H16.675L12.1 1.4L13.5 0L20.5 7L13.5 14Z"
        fill="#007DFF"
      />
    </svg>
  );
};
